/**
 * カレンダー - コンポーネント
 * @see 日ではなく週単位で選択の場合
 * @see ABUI_doc__Component_Datepicker.html
 */
{
  let dateFormat,
      endDate,
      inputVal,
      res,
      selectedDate,
      startDate,
      today;

  const options = {
    altField:               "",
    altFormat:              "",
    appendText:             "",
    autoSize:               !1,
    beforeShow:             null,
    beforeShowDay:          null,
    buttonImage:            "",
    buttonImageOnly:        !1,
    buttonText:             '<span class="input-icon icon-abui-calendar-solid"></span>',
    // buttonText:             "...",
    calculateWeek:          getFiscalWeek,
    changeMonth:            !1,
    changeYear:             !1,
    constrainInput:         !0,
    dateFormat:             "yy/mm/dd",
    defaultDate:            null,
    disabled:               !1,
    duration:               "fast",
    firstDay:               0,
    gotoCurrent:            !1,
    hideIfNoPrevNext:       !1,
    maxDate:                null,
    minDate:                null,
    navigationAsDateFormat: !1,
    numberOfMonths:         1,
    onChangeMonthYear:      null,
    selectOtherMonths:      true,
    shortYearCutoff:        "+10",
    showAnim:               "fadeIn",
    showButtonPanel:        !1,
    showCurrentAtPos:       0,
    showOn:                 "focus",
    showOptions:            {},
    showOtherMonths:        true,
    showWeek:               false,
    stepBigMonths:          12,
    stepMonths:             1,
    yearRange:              "c-10:c+10"
  };

  /**
   * [getFiscalWeek description]
   * @type   {Function}
   * @param  {Object} d 月の週始めの日付
   * @return {Number}   週目
   */
  var getFiscalWeek = function(d){
    const date     = new Date(d.getTime());
    const firstday = new Date(getFC(date), 3, 1);
    const fulldays = Math.floor((date.getTime() - firstday.getTime()) / (1000 * 86400));

    /**
     * [getFC description]
     * @param  {Object} val     月の週始めの日付
     * @return {Number} result  年
     */
    function getFC(val) {
      let result = "日付文字列が不正です。";  //日付不正時のメッセージ
      try {
        const y = val.getFullYear();
        const m = val.getMonth();
        const d = val.getDate();
        const dt = new Date(y, m, d);
        if(m < 3){  //4月はじまり
          result = y-1;
        } else {
          result = y;
        }
        return result;
      } catch(ex){
        return result;
      }
    }

    return Math.floor((fulldays - date.getDay() + 12 ) / 7);
  };

  const methods = {
    init : function(args) {
      const input  = $(this);
      const widget = $(this).datepicker('widget');

      if (args) {
        options.altField               = typeof(args.altField) != 'undefined' && args.altField ? args.altField : "";
        options.altFormat              = typeof(args.altFormat) != 'undefined' && args.altFormat ? args.altFormat : "";
        options.appendText             = typeof(args.appendText) != 'undefined' && args.appendText ? args.appendText : "";
        options.autoSize               = typeof(args.autoSize) != 'undefined' && args.autoSize ? args.autoSize : !1;
        options.buttonImage            = typeof(args.buttonImage) != 'undefined' && args.buttonImage ? args.buttonImage : "";
        options.buttonImageOnly        = typeof(args.buttonImageOnly) != 'undefined' && args.buttonImageOnly ? args.buttonImageOnly : !1;
        // options.buttonText             = typeof(args.buttonText) != 'undefined' && args.buttonText ? args.buttonText : "...";
        options.calculateWeek          = getFiscalWeek;
        options.changeMonth            = typeof(args.changeMonth) != 'undefined' && args.changeMonth ? args.changeMonth : !1;
        options.changeYear             = typeof(args.changeYear) != 'undefined' && args.changeYear ? args.changeYear : !1;
        options.constrainInput         = typeof(args.constrainInput) != 'undefined' && args.constrainInput ? args.constrainInput : !0;
        options.dateFormat             = typeof(args.dateFormat) != 'undefined' && args.dateFormat ? args.dateFormat : "yy/mm/dd";
        options.defaultDate            = typeof(args.defaultDate) != 'undefined' && args.defaultDate ? args.defaultDate : null;
        options.disabled               = typeof(args.disabled) != 'undefined' && args.disabled ? args.disabled : !1;
        options.duration               = typeof(args.duration) != 'undefined' && args.duration ? args.duration : "fast";
        options.firstDay               = typeof(args.firstDay) != 'undefined' && args.firstDay ? args.firstDay : 0;
        options.gotoCurrent            = typeof(args.gotoCurrent) != 'undefined' && args.gotoCurrent ? args.gotoCurrent : !1;
        options.hideIfNoPrevNext       = typeof(args.hideIfNoPrevNext) != 'undefined' && args.hideIfNoPrevNext ? args.hideIfNoPrevNext : !1;
        options.maxDate                = typeof(args.maxDate) != 'undefined' && args.maxDate ? args.maxDate : null;
        options.minDate                = typeof(args.minDate) != 'undefined' && args.minDate ? args.minDate : null;
        options.navigationAsDateFormat = typeof(args.navigationAsDateFormat) != 'undefined' && args.navigationAsDateFormat ? args.navigationAsDateFormat : !1;
        options.numberOfMonths         = typeof(args.numberOfMonths) != 'undefined' && args.numberOfMonths ? args.numberOfMonths : 1;
        options.onChangeMonthYear      = typeof(args.showOn) != 'undefined' && args.onChangeMonthYear ? args.onChangeMonthYear : null;
        options.selectOtherMonths      = true;
        options.shortYearCutoff        = typeof(args.shortYearCutoff) != 'undefined' && args.shortYearCutoff ? args.shortYearCutoff : "+10";
        options.showAnim               = typeof(args.showAnim) != 'undefined' && args.showAnim ? args.showAnim : "fadeIn";
        options.showButtonPanel        = typeof(args.showButtonPanel) != 'undefined' && args.showButtonPanel ? args.showButtonPanel : !1;
        options.showCurrentAtPos       = typeof(args.showCurrentAtPos) != 'undefined' && args.showCurrentAtPos ? args.showCurrentAtPos : 0;
        options.showOn                 = typeof(args.showOn) != 'undefined' && args.showOn ? args.showOn : "focus";
        options.showOptions            = typeof(args.showOptions) != 'undefined' && args.showOptions ? args.showOptions : {};
        options.showOtherMonths        = true;
        options.showWeek               = typeof(args.showWeek) != 'undefined' && args.showWeek ? true : false;
        options.stepBigMonths          = typeof(args.stepBigMonths) != 'undefined' && args.stepBigMonths ? args.stepBigMonths : 12;
        options.stepMonths             = typeof(args.stepMonths) != 'undefined' && args.stepMonths ? args.stepMonths : 1;
        options.yearRange              = typeof(args.yearRange) != 'undefined' && args.yearRange ? args.yearRange : "c-10:c+10";
      }

      options.onClose = function(){
        if (typeof(startDate) != 'undefined') {
          $(this).datepicker('setDate', startDate);
          $(this).val(inputVal);
        }

        widget.removeClass('ui-weekpicker-calendar').removeClass('withWeekNum');
        widget.hide().addClass('hideWeekpicker');
      }

      options.onSelect = function(dateText, inst) {
        $(this).blur();
        const date = $(this).datepicker('getDate');
        if (date.getDay() == 0 &&  inst.settings.firstDay == 1) {
          startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - (7 - inst.settings.firstDay));
          endDate   = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        } else {
          startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + inst.settings.firstDay);
          endDate   = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + 6 + inst.settings.firstDay);
        }
        today        = new Date();
        dateFormat   = inst.settings.dateFormat || $.datepicker._defaults.dateFormat;
        inputVal     = $.datepicker.formatDate( dateFormat, startDate, inst.settings ) + '〜' + $.datepicker.formatDate( dateFormat, endDate, inst.settings );
        selectedDate = startDate;

        widget.hide().addClass('hideWeekpicker');
      };

      options.beforeShow = function(input, inst) {
        widget.addClass('ui-weekpicker-calendar');

        if (inst.settings.showWeek) {
          widget.addClass('withWeekNum');
        }

        setTimeout(function(){
          widget.css('opacity', '0').removeClass('hideWeekpicker').addClass('fadeInWeekpicker')
        },0)
        inputVal = $(this).val();
        $(this).datepicker('setDate', startDate);
      },

      options.beforeShowDay = function(date) {
        let cssClass = '';
        if (typeof(startDate) !== 'undefined' && typeof(endDate) !== 'undefined') {
          if (date >= startDate && date <= endDate) {
            cssClass = 'ui-datepicker-current-day';
          } else if (today < startDate || today > endDate) {
            cssClass = 'reset-ui-active';
          } else {
            cssClass = '';
          }
        }

        let e = event;
        setTimeout(function(){
          input.datepicker('widget').find('.ui-datepicker-current-day:not(.reset-ui-active)').parents('tr').addClass('ui-datepicker-current-week');
          input.val(inputVal);
        });

        return [true, cssClass];
      },

      this.attr('component-type', 'weekpicker');

      this.datepicker(options);

      if (this.val()) {
        const date = new Date(this.val().split('〜')[0]);
        if (date.getDay() == 0 &&  options.firstDay == 1) {
          startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - (7 - options.firstDay));
          endDate   = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        } else {
          startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + options.firstDay);
          endDate   = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + 6 + options.firstDay);
        }
        today = new Date();

        this.datepicker('setDate', startDate);
        dateFormat = options.dateFormat || $.datepicker._defaults.dateFormat;
        res        = $.datepicker.formatDate( dateFormat, startDate, options ) + '〜' + $.datepicker.formatDate( dateFormat, endDate, options );
        inputVal   = res;
      }
    },
    setWeek: function(date) {
      date = new Date(date);
      if (date.getDay() == 0 &&  options.firstDay == 1) {
        startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - (7 - options.firstDay));
        endDate   = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      } else {
        startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + options.firstDay);
        endDate   = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() + 6 + options.firstDay);
      }
      today = new Date();

      this.datepicker('setDate', startDate);
      dateFormat = options.dateFormat || $.datepicker._defaults.dateFormat;
      res        = $.datepicker.formatDate( dateFormat, startDate, options ) + '〜' + $.datepicker.formatDate( dateFormat, endDate, options );
      inputVal   = res;
    },
    getWeek: function() {
      return {startDate: $(this).val().split('〜')[0],endDate: $(this).val().split('〜')[1]}
    }
  }

  $.fn.weekpicker = function(method) {
    if ( methods[method] ) {
      return methods[ method ].apply( this, Array.prototype.slice.call( arguments, 1 ));
    } else if ( typeof method === 'object' || ! method ) {
      return methods.init.apply( this, arguments );
    } else {
      $.error( 'Method ' +  method + ' is not a function' );
    }
  }
}